<div class="participant-container">
  <div class="participant-header">
    <mat-icon class="icon" svgIcon="human-{{ approval?.recipient?.gender === 'M' ? 'male' : 'female' }}"></mat-icon>
    <div class="participant-details">
      <p class="name">
        <span *ngIf="approval?.recipient?.firstName || approval?.recipient?.lastName; else showDob">
          {{ approval?.recipient?.firstName }} {{ approval?.recipient?.lastName }}
        </span>
        <ng-template #showDob>{{ approval?.recipient?.dob }}</ng-template>
      </p>
      <p class="type">{{ approval?.recipient?.type }}</p>

      <p *ngIf="approval?.recipient?.center">
        <label>Center</label>
        {{ approval?.recipient?.center?.name }}
      </p>
      <p>
        <label>Date of birth</label>
        {{ approval?.recipient?.dob | date: "d MMM y" }}
        <span class="age">({{ age }} years old)</span>
      </p>

      <p *ngIf="approval?.recipient?.urgency && approval?.recipient?.abo">
        <label>Blood group / Ki-Urgency</label>
        {{ approval?.recipient?.abo }} / {{ approval?.recipient?.urgency }}
      </p>
      <p *ngIf="approval?.recipient?.abo && !approval?.recipient?.urgency">
        <label>Blood group</label>
        {{ approval?.recipient?.abo }}
      </p>
      <p *ngIf="approval?.recipient?.abPhenotype">
        <label>HLA Class I</label>
        {{ approval?.recipient?.abPhenotype }}
      </p>
      <p *ngIf="approval?.recipient?.drPhenotype">
        <label>HLA Class II</label>
        {{ approval?.recipient?.drPhenotype }}
      </p>
      <p *ngIf="approval?.recipient?.unacceptables">
        <label>Unacceptables</label>
        {{ approval?.recipient?.unacceptables }}
      </p>
      <p *ngIf="approval?.recipient?.dateScreening">
        <label>Last screening</label>
        {{ approval?.recipient?.dateScreening | date: "d MMM y" }}
      </p>
      <p *ngIf="approval?.recipient?.primaryDiagnosis">
        <label>Primary diagnosis</label>
        {{ approval?.recipient?.primaryDiagnosis }}
      </p>

      <p *ngIf="approval?.recipient?.previousPRA">
        <label>Returned waiting days</label>
        {{ approval?.recipient?.previousPRA }}
      </p>
      <p *ngIf="approval?.recipient?.virtualPRA">
        <label>Current vPRA</label>
        {{ approval?.recipient?.virtualPRA }}%
      </p>

      <p *ngIf="approval?.recipient?.lastUpdate">
        <label>Last updated</label>
        {{ approval?.recipient?.lastUpdate | date: "d MMM y, HH:mm:ss" }}
      </p>

      <!-- Privileges Section -->
      <p *ngIf="approval?.recipient?.extraWaitTime">
        <label>Extra Wait Time<span class="privilege-indicator"></span></label>
        Yes
      </p>

      <p *ngIf="approval?.recipient?.maxDonorAge">
        <label>Max Donor Age<span class="privilege-indicator"></span></label>
        {{ approval?.recipient?.maxDonorAge }}
      </p>

      <p *ngIf="approval?.recipient?.maxMismatches">
        <label>Max mismatches<span class="privilege-indicator"></span></label>
        {{ approval?.recipient?.maxMismatches }}
      </p>
      <p *ngIf="approval?.recipient?.maxMmA">
        <label>Max mm A<span class="privilege-indicator"></span></label>
        {{ approval?.recipient?.maxMmA }}
      </p>
      <p *ngIf="approval?.recipient?.maxMmB">
        <label>Max mm B<span class="privilege-indicator"></span></label>
        {{ approval?.recipient?.maxMmB }}
      </p>
      <p *ngIf="approval?.recipient?.maxMmDR">
        <label>Max mm DR<span class="privilege-indicator"></span></label>
        {{ approval?.recipient?.maxMmDR }}
      </p>
      <p *ngIf="approval?.recipient?.acceptableBloodTypes">
        <label>Acceptable Bloodtypes<span class="privilege-indicator"></span></label>
        {{ formattedAcceptableBloodTypes }}
      </p>
      <p *ngIf="approval?.recipient?.acceptableHla">
        <label>Delisted Unacceptables<span class="privilege-indicator"></span></label>
        {{ approval?.recipient?.acceptableHla }}
      </p>
    </div>
  </div>

  <div class="history-container">
    <h3>Request</h3>
    <div class="history-item">
      <label *ngIf="approval?.approvalReason">Approval reason:</label>
      <span *ngIf="approval?.approvalReason">{{ approval?.approvalReason }}</span>
      <label>Approval for :</label><strong *ngIf="!approval?.value">{{ approvalColumnLabels[approval!.approvalColumn] }} </strong>
      <strong *ngIf="approval?.value">{{ approvalColumnLabels[approval!.approvalColumn] }} → {{ approval?.value }} </strong>

      <!-- Display requested privileges for priority requests -->
      <div *ngIf="approval?.approvalColumn === 'priority' && (approval?.requestedAcceptableHla || approval?.requestedAcceptableBloodTypes)" class="requested-privileges">
        <label>Requested Additional Privileges:</label>
        <div *ngIf="approval?.requestedAcceptableHla" class="privilege-item">
          <strong>Delisted Unacceptables:</strong> {{ approval?.requestedAcceptableHla }}
        </div>
        <div *ngIf="approval?.requestedAcceptableBloodTypes" class="privilege-item">
          <strong>Acceptable Blood Types:</strong> {{ approval?.requestedAcceptableBloodTypes }}
        </div>
      </div>

      <label>Status :</label><strong>{{ approval?.status | titlecase }} </strong>

      <label>Request Date:</label> {{ approval?.dateCreated | date: "d MMM y, HH:mm:ss" }}

      <div *ngIf="approval?.dateProcessed && approval?.status === 'approved'">
        <label>Approved on:</label> {{ approval?.dateProcessed | date: "d MMM y, HH:mm:ss" }}
      </div>

      <div *ngIf="approval?.dateProcessed && approval?.status === 'closed'">
        <label>Denied on:</label> {{ approval?.dateProcessed | date: "d MMM y, HH:mm:ss" }}
      </div>

      <label>
        <ng-container *ngIf="approval?.status === 'approved'">Request approved by:</ng-container>
        <ng-container *ngIf="approval?.status === 'closed'">Request denied by:</ng-container>
        <ng-container *ngIf="approval?.status === 'pending'">Request by:</ng-container>
      </label> {{ approval?.approvalByUser }}

      <!-- Display request comment if present -->
      <div *ngIf="approval?.requestComment" class="request-comment">
        <label>Request Comment:</label>
        <div class="comment-content" [innerHTML]="sanitizedRequestComment"></div>
      </div>
    </div>
  </div>
  <div class="spacer"></div>
</div>
